import { Injectable } from '@angular/core';
import { BaseService } from '../../../../shared/services/base.service';
import { IndividualWaitingModel } from '../../../../models/waiting-room/individual-waiting.model';
import { ConsultationType, ConsultationValue } from '../../../../models/consultation/consultation.model';
import { CentreUrl } from '../../../../shared/urls/centre.url';
import { Utility } from '../../../../common/utility';
import { ConsultationUrl } from '../../../../shared/urls/consultation.url';

@Injectable()
export class IndividualWaitingService {
    constructor(public baseService: BaseService) {
    }

    getWaitingList(param, isUpdateLastedDate) {
        let url = CentreUrl.GET_WAITING_ROOM;
       return this.baseService.getData(url, param, true, true, isUpdateLastedDate);
    }
    removePatientFromWaitingRoom(id: string) {
        let url = CentreUrl.REMOVE_PATIENT_FROM_WAITING_ROOM.replace('consultationId', id);
        return this.baseService.postData(url, null);
    }

    updateCreateDateConsultation(consultationId, data){
        const url = Utility.stringFormat(ConsultationUrl.UPDATE_CREATE_DATE_CONSULTATION, [consultationId]);
        return this.baseService.postData(url, data);
    }
}

//  const data: IndividualWaitingModel[] = [
//     {
//         id: "1",
//         patientREF: "HUN10000HC",
//         userId: '1',
//         name: "Hung Vuong",
//         dateOfBirth: 1413173580,
//         group: "Individual",
//         clinic: "FLU",
//         arrivalTime: 1477239180,
//         departTime:1477239180,
//         accounts: "Accounts",
//         status: ConsultationType.Consultation,
//         isInvoiceOverDue: false
//     },
//     {
//         id: "2",
//         patientREF: "HUN10000HC",
//         userId: '2',
//         name: "Hung Vuong",
//         dateOfBirth: 1413173580,
//         group: "Individual",
//         clinic: "FLU",
//         arrivalTime: 1477239180,
//         departTime:1477239180,
//         accounts: "Accounts",
//         status: ConsultationType.InConsultation,
//         isInvoiceOverDue: false
//     },
//     {
//         id: "3",
//         patientREF: "HUN10000HC",
//         userId: '3',
//         name: "Hung Vuong",
//         dateOfBirth: 1413173580,
//         group: "Individual",
//         clinic: "FLU",
//         arrivalTime: 1477239180,
//         departTime:1477239180,
//         accounts: "Accounts",
//         status: ConsultationType.AdministerVaccine,
//         isInvoiceOverDue: false
//     },
//     {
//         id: "4",
//         patientREF: "HUN10000HC",
//         userId: '4',
//         name: "Hung Vuong",
//         dateOfBirth: 1413173580,
//         group: "Individual",
//         clinic: "FLU",
//         arrivalTime: 1477239180,
//         departTime:1477239180,
//         accounts: "Accounts",
//         status: ConsultationType.Invoice,
//         isInvoiceOverDue: false
//     },
//     {
//         id: "5",
//         patientREF: "HUN10000HC",
//         userId: '5',
//         name: "Hung Vuong",
//         dateOfBirth: 1413173580,
//         group: "Individual",
//         clinic: "FLU",
//         arrivalTime: 1477239180,
//         departTime:1477239180,
//         accounts: "Accounts",
//         status: ConsultationType.LabTest,
//         isInvoiceOverDue: false
//     }
// ];





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/individual/individual.service.ts